/**
 *   Packages
 * ------------------------------------------------------ */
import React from 'react';

/**
 *   Components
 * ------------------------------------------------------ */
import { Box } from 'grommet';
import { LinkPrevious } from 'grommet-icons';

/**
 *   Helpers
 * ------------------------------------------------------ */
import { BackButtonProps } from './BackButton.d';
import { useHistory } from 'react-router-dom';

const BackButton: React.FC<BackButtonProps> = ({
  customBackUrl,
  style,
  onClick,
}) => {
  const history = useHistory();

  const handleOnClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    customBackUrl ? history.push(customBackUrl) : history.goBack();
  };

  return (
    <Box
      alignSelf="start"
      background="white"
      elevation="small"
      pad="small"
      round="full"
      style={style}
      onClick={handleOnClick}
    >
      <LinkPrevious size="24px" />
    </Box>
  );
};

export default BackButton;
